import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MultiSelectDropDownWithSearchComponent } from './multi-select-drop-down-with-search/multi-select-drop-down-with-search.component';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { PipesModule } from 'src/app/pipes/pipes.module';


@NgModule({
  declarations: [
    MultiSelectDropDownWithSearchComponent
  ],
  imports: [
    CommonModule,
    AutoCompleteModule,
    FormsModule,
    ReactiveFormsModule,
    PipesModule
  ],
  exports: 
  [MultiSelectDropDownWithSearchComponent]
})
export class MultipleSelectDropDownWithSearchModule { }
